import "./style.css";

const ModalTitle = ({ text, className, bordered }) => {
  return (
    <p
      className={`text-base-lg weight-500 text-center modal-title ${
        className || ""
      } ${bordered ? "bordered-title" : ""} `}
    >
      {text}
    </p>
  );
};

export default ModalTitle;
